import { DataShed } from "./sheds/base"
import { WirelessConfigDepo } from "./depos/wireless_config"
import { MapDepo } from "./depos/map"
import eventBus from "@ciq/shared/hooks/eventBus"

class DataWareHouse {
  constructor() {
    this.users = new DataShed()
    this.schools = new DataShed()
    this.wireless_config = new WirelessConfigDepo()
    this.map = new MapDepo()

    // Listen to school change events from the eventBus
    eventBus.on("school:changed", () => {
      this.wireless_config.clear()
    })
  }

  addSchoolChangeListener(callback) {
    eventBus.on("school:changed", callback)
  }

  removeSchoolChangeListener(callback) {
    eventBus.off("school:changed", callback)
  }
}

const WareHouse = new DataWareHouse()

export default WareHouse
